module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-3-ca1cbbf01f6b2398073ad3e4fb2bfae3.svg";